class IngredientsSlide extends HTMLElement {
  constructor() {
    super();
    this.elem = this.querySelector(".ingredients-product__list");
    this.flkty = new Flickity( this.elem, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      watchCSS: true
    });

    this.querySelector(".js-slider-arrows__next").addEventListener("click", () => {
      this.flkty.next();
    })
  
    this.querySelector(".js-slider-arrows__prev").addEventListener("click", () => {
      this.flkty.previous();
    })
  
  }
}
customElements.define("ingredients-slide", IngredientsSlide)